import { render, staticRenderFns } from "./TestAction.vue?vue&type=template&id=2d7f8d0c"
import script from "./TestAction.vue?vue&type=script&lang=js"
export * from "./TestAction.vue?vue&type=script&lang=js"
import style0 from "./TestAction.vue?vue&type=style&index=0&id=2d7f8d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports